import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Inject,
    Injector,
    ViewEncapsulation,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { IDialogConfirmDeleteData } from './dialog-confirm-delete-data';
import { FI_DIALOGS_CONTENT_DATA, FiDialogsContentBase } from '../../fi-dialogs/fi-dialogs-content-base';
import { FiDialogsContainerBase } from '../../fi-dialogs/fi-dialogs-container-base';

@Component({
    selector: 'fi-dialog-confirm-delete',
    templateUrl: './dialog-confirm-delete.component.html',
    styleUrls: ['./dialog-confirm-delete.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-dialog-confirm-delete' },
    standalone: false,
})
export class FiDialogConfirmDeleteComponent extends FiDialogsContentBase<IDialogConfirmDeleteData, boolean> {
    step: number = 1;
    confirmText2: string = '';

    confirmText: string;
    confirmTextToInput: string;
    varX: number;
    varY: number;
    confirmTextToInput2: string;
    confirmTextToInput2Message: string;

    constructor(
        dialogRef: MatDialogRef<FiDialogsContainerBase<IDialogConfirmDeleteData, boolean>>,
        injector: Injector,
        @Inject(FI_DIALOGS_CONTENT_DATA) data: IDialogConfirmDeleteData,
        private cdr: ChangeDetectorRef,
    ) {
        super(dialogRef, data, injector);

        this.confirmText = '';
        if (this.data.hasOwnProperty('step1')) {
            this.confirmTextToInput = this.data.step1.confirmTextToInput;
        } else {
            this.step = 2;
        }

        this.varX = Math.floor(Math.random() * 10);
        this.varY = Math.floor(Math.random() * 10);

        this.confirmText2 = '';
        this.confirmTextToInput2 = (this.varX + this.varY).toString();
        this.confirmTextToInput2Message = this.varX.toString() + ' + ' + this.varY.toString() + ' = ';
    }

    getYesButtonText() {
        if (this.step === 1)
            return this.data.step1.preventUppercaseButtonLabel
                ? this.data.step1.buttonText
                : this.data.step1.buttonText.toUpperCase();

        if (typeof this.data.step2) {
            return this.data.step2.preventUppercaseButtonLabel
                ? this.data.step2.buttonText
                : this.data.step2.buttonText.toUpperCase();
        }
    }

    onYesButtonClick($event) {
        if (this.step === 1 && this.data.step2) {
            $event.preventDefault();
            this.step = 2;
            this.cdr.markForCheck();
        }
    }

    isYesButtonDisabled() {
        return (
            (this.step === 1 && this.confirmText !== this.confirmTextToInput) ||
            (this.step === 2 && this.confirmText2 !== this.confirmTextToInput2)
        );
    }
}
